import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";
import { downloadBlob } from "../../../utils/functions/downloadBlob";

export const doReportOperator = createAsyncThunk(
  "operatorManagement/get-report-operator",
  async (reportOperatorData, thunkAPI) => {
    const endpoint = "/admin/commercialista/export";
    const response = await client.get(endpoint, null, { type: "blob" });
    downloadBlob("Report operatore.xls", response);
  }
);
